import React from "react";
import { createPortal } from "react-dom";

interface TestResult {
  success: boolean;
  order: {
    price: number;
    amount: number;
    orderId?: string;
  };
  error?: string;
  timestamp: number;
}

interface TestResultsModalProps {
  isOpen: boolean;
  onClose: () => void;
  testResults: TestResult[];
  onClearResults: () => void;
}

export const TestResultsModal: React.FC<TestResultsModalProps> = ({
  isOpen,
  onClose,
  testResults,
  onClearResults,
}) => {
  if (!isOpen) return null;

  const successCount = testResults.filter((r) => r.success).length;
  const failedCount = testResults.filter((r) => !r.success).length;

  return typeof document !== "undefined"
    ? createPortal(
        <div className="test-results-modal-overlay" onClick={onClose}>
          <div
            className="test-results-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="test-results-modal-header">
              <h3>Batch Transaction Results</h3>
            </div>
            <div className="test-results-modal-body">
              {/* Summary */}
              <div className="test-results-modal-summary">
                <div className="test-results-modal-summary-text">
                  <strong>Total:</strong> {testResults.length} |{" "}
                  <strong className="success">Success:</strong> {successCount} |{" "}
                  <strong className="error">Failed:</strong> {failedCount}
                </div>
                <button
                  onClick={onClearResults}
                  className="test-results-modal-clear-button"
                >
                  Clear Results
                </button>
              </div>

              {/* Results List */}
              <div className="test-results-modal-list">
                {testResults.length === 0 ? (
                  <div className="test-results-modal-empty">
                    No results to display
                  </div>
                ) : (
                  testResults.slice(-20).map((result, index) => (
                    <div
                      key={index}
                      className={`test-results-modal-item ${
                        result.success ? "success" : "error"
                      }`}
                    >
                      <div className="test-results-modal-item-content">
                        <div className="test-results-modal-item-header">
                          <strong
                            className={`test-results-modal-item-title ${
                              result.success ? "success" : "error"
                            }`}
                          >
                            {result.success ? "✓" : "✗"} Order @{" "}
                            {result.order.price.toFixed(2)} USDC
                          </strong>
                        </div>
                        <div className="test-results-modal-item-details">
                          <span>
                            Amount: {result.order.amount.toFixed(4)} BTC
                          </span>
                          {result.order.orderId && (
                            <span>
                              Order ID: {result.order.orderId.substring(0, 16)}
                              ...
                            </span>
                          )}
                        </div>
                        {result.error && (
                          <span className="test-results-modal-error-text">
                            Error: {result.error}
                          </span>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className="test-results-modal-footer">
              <button
                onClick={onClose}
                className="test-results-modal-close-button"
              >
                Close
              </button>
            </div>
          </div>
        </div>,
        document.body
      )
    : null;
};
